import { css } from '@emotion/react'
import { Divider, Typography } from '@mui/material'
import { String } from 'effect'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { signIn, useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { Fragment, useContext } from 'react'
import { match } from 'ts-pattern'
import { Button, ButtonVariant } from 'components/common/Button'
import { NewFlexContainer } from 'components/common/common.style'
import { unifiedColors } from 'styles/colors'
import { AuthModal } from './AuthModal'
import { TitleText } from './AuthModal.style'
import { AuthModalContext } from './AuthModalContext'
import { SponsorContainer } from './SignInModal.style'
import SponsorImage from './SponsorImage'

export const SponsorModal = () => {
  const {
    setModalParams,
    modalParams: { redirectUrl, sponsors }
  } = useContext(AuthModalContext)

  const session = useSession()

  const { t } = useTranslation('authentication')
  const router = useRouter()

  const handleContinueWithoutSponsor = () =>
    match(session.status)
      .with('authenticated', () => {
        router.push(redirectUrl)
      })
      .with('unauthenticated', () => {
        setModalParams({
          state: 'SIGNIN',
          redirectUrl,
          sponsors
        })
      })
      .with('loading', () => {})
      .exhaustive()

  return (
    <AuthModal modalState="SPONSOR">
      <TitleText>{t('sponsor.title')}</TitleText>
      <NewFlexContainer flexDirection="column" gap="8px" alignItems="center">
        {(sponsors || []).map((sponsor, index) => (
          <Fragment key={sponsor.id}>
            <SponsorContainer
              flexDirection="column"
              gap="12px"
              alignItems="center"
            >
              {sponsor.imageCta ? (
                <NewFlexContainer
                  flexDirection="column"
                  gap="12px"
                  alignItems="center"
                >
                  <SponsorImage sponsor={sponsor} />
                  <Button
                    label={`${t('sponsor.continueWith')} ${String.capitalize(
                      sponsor.name
                    )}`}
                    variant={ButtonVariant.Primary}
                    onClick={() => {
                      signIn(sponsor.sso.providerId, {
                        callbackUrl: redirectUrl
                      })
                    }}
                  />
                </NewFlexContainer>
              ) : (
                <>
                  <Typography
                    variant="body2"
                    color={unifiedColors.label.subdued}
                  >
                    {sponsor.sso.prompt?.['fr']}
                  </Typography>
                  {sponsor.sso.logoUrl && (
                    <Image
                      src={sponsor.sso.logoUrl}
                      alt={sponsor.name}
                      fill
                      onClick={() =>
                        signIn(sponsor.sso.providerId, {
                          callbackUrl: redirectUrl
                        })
                      }
                      css={css`
                        cursor: pointer;
                        position: inherit !important;
                        height: 35px !important;
                        width: auto !important;
                        background-color: ${unifiedColors.label.subdued};
                      `}
                    />
                  )}
                </>
              )}
            </SponsorContainer>
            {index !== (sponsors || []).length - 1 && (
              <Divider
                sx={{
                  width: '100%'
                }}
              >
                {t('or')}
              </Divider>
            )}
          </Fragment>
        ))}
        <Divider
          sx={{
            width: '100%'
          }}
        >
          {t('or')}
        </Divider>
        <NewFlexContainer padding="0 0 10px">
          <Button
            label={t('sponsor.continueWithoutSponsor')}
            variant={ButtonVariant.Primary}
            onClick={handleContinueWithoutSponsor}
          />
        </NewFlexContainer>
      </NewFlexContainer>
    </AuthModal>
  )
}
